import { merge } from 'lodash';
import { removeEmptyEntries } from '../..';
import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';

export const reportSnippetClickEvent = (type, { encryptedOrderId }) => {
    const baseFields = getBQClickFields({
        type,
        elementName: 'reviews snippet',
        componentName: 'gig_review',
    });

    tracker.sendBQEvent(
        merge(baseFields, {
            page: {
                element: {
                    type: 'button',
                },
            },
            order: {
                encrypted_id: encryptedOrderId,
            },
        })
    );

    tracker.sendMixPanelEvent({
        eventName: TYPES.snippetMixpanelClick,
        eventPayload: removeEmptyEntries({
            'Clicked element': type,
        }),
    });
};

export const reportSnippetViewMixpanel = (additionalFields = {}) => {
    tracker.sendMixPanelEvent({
        eventName: TYPES.snippetMixpanelView,
        eventPayload: additionalFields,
    });
};

export const TYPES = {
    snippetMixpanelView: 'Viewed Reviews Snippet',
    snippetMixpanelClick: 'Click On Review Snippet',
    snippetNextClicked: 'clicked_on_next_review',
    snippetPrevClicked: 'clicked_on_prev_review',
};
